// Utils for DatePicker change handlers with time synchronization logic

/**
 * Handle start date change with time synchronization for end date
 * @param {Date} date - New date selected
 * @param {Date} startDate - Current start date
 * @param {Date} endDate - Current end date
 * @param {Function} setStartDate - Setter for start date
 * @param {Function} setEndDate - Setter for end date
 */
export const handleStartDateChange = (date, startDate, endDate, setStartDate, setEndDate) => {
    const mismoDia = startDate.getDate() === date.getDate() && startDate.getMonth() === date.getMonth() && startDate.getFullYear() === date.getFullYear();
    const nuevaFecha = mismoDia ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate(), startDate.getHours(), startDate.getMinutes(), startDate.getSeconds());
    setStartDate(nuevaFecha);
    if (nuevaFecha.getDate() > endDate.getDate() || nuevaFecha.getMonth() > endDate.getMonth() || nuevaFecha.getFullYear() > endDate.getFullYear()) {
        setEndDate(new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), 23, 59, 59));
    } else if (nuevaFecha.getDate() === endDate.getDate() && nuevaFecha.getMonth() === endDate.getMonth() && nuevaFecha.getFullYear() === endDate.getFullYear()) {
        // Same day, check time
        let adjustedEndDate;
        if (endDate.getHours() < nuevaFecha.getHours() ||
            (endDate.getHours() === nuevaFecha.getHours() && endDate.getMinutes() < nuevaFecha.getMinutes()) ||
            (endDate.getHours() === nuevaFecha.getHours() && endDate.getMinutes() === nuevaFecha.getMinutes() && endDate.getSeconds() < nuevaFecha.getSeconds())) {
            adjustedEndDate = new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), 23, 59, 59);
        } else {
            adjustedEndDate = new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
        }
        setEndDate(adjustedEndDate);
    }
};

/**
 * Handle end date change with time validation against start date
 * @param {Date} date - New date selected
 * @param {Date} startDate - Current start date
 * @param {Date} endDate - Current end date
 * @param {Function} setEndDate - Setter for end date
 */
export const handleEndDateChange = (date, startDate, endDate, setStartDate, setEndDate) => {
    const mismoDia = endDate.getDate() === date.getDate() && endDate.getMonth() === date.getMonth() && endDate.getFullYear() === date.getFullYear();
    const nuevaFecha = mismoDia ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());

    // Si es el mismo día que startDate y la hora nueva es anterior a startDate, ajusta a la hora de startDate
    if (date.getDate() === startDate.getDate() && date.getMonth() === startDate.getMonth() && date.getFullYear() === startDate.getFullYear() &&
        (date.getHours() < startDate.getHours() ||
            (date.getHours() === startDate.getHours() && date.getMinutes() < startDate.getMinutes()) ||
            (date.getHours() === startDate.getHours() && date.getMinutes() === startDate.getMinutes() && date.getSeconds() < startDate.getSeconds()))) {
        setEndDate(nuevaFecha);
        setStartDate(nuevaFecha);
    } else {
        setEndDate(nuevaFecha);
    }
};